import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { 
  FETCH_CONVERSACIONES_USERS_REQUEST,
  FETCH_CONVERSACIONES_USERS_SUCCESS,
  FETCH_CONVERSACIONES_USERS_FAILURE,
  SET_CONVERSACION_SELECCIONADA,
  FETCH_MENSAJES_CONVERSACION_REQUEST,
  FETCH_MENSAJES_CONVERSACION_SUCCESS,
  FETCH_MENSAJES_CONVERSACION_FAILURE,
  SET_NUEVO_MENSAJE_CONVERSACION,
  SET_UPDATE_LAST_MESSAGE,
  SET_NUEVA_CONVERSACION,
  UPDATE_MENSAJE_CONVERSACION, 
} from "../../../../constants/chat/Conversaciones/Conversaciones";
import { RootState } from "../../../store/store";
import { AnyAction } from "redux-saga";
import { message } from 'antd';
import fetchWithIP from "../../utils/FechHeaders";
import { Mensajes } from "../../../../types/chat/conversaciones/Conversaciones";

export const fetchChatConversacionesRequest = () => ({
  type: FETCH_CONVERSACIONES_USERS_REQUEST
});

export const fetchChatConversacionesSuccess = (data: any, meta:any) => ({
  type: FETCH_CONVERSACIONES_USERS_SUCCESS,
  payload: {
    data,
    meta
  }
});

export const fetchChatConversacionesFailure = (error: string) => ({
  type: FETCH_CONVERSACIONES_USERS_FAILURE,
  payload: error
});

export const fetchMensajesConversacionRequest = () => ({
  type: FETCH_MENSAJES_CONVERSACION_REQUEST
});

export const fetchMensajesConversacionSuccess = (data: any, meta:any) => ({
  type: FETCH_MENSAJES_CONVERSACION_SUCCESS,
  payload: {
    data,
    meta
  }
});

export const fetchMensajesConversacionFailure = (error: string) => ({
  type: FETCH_MENSAJES_CONVERSACION_FAILURE,
  payload: error
});

export const setConversacionSeleccionadaAction = (conversation: any) => ({
  type: SET_CONVERSACION_SELECCIONADA,
  payload: conversation
});

export const setNuevoMensajeConversacionAction = (mensaje: Mensajes) => ({
  type: SET_NUEVO_MENSAJE_CONVERSACION,
  payload: mensaje
});

export const setUpdateLastMessageAction = (mensaje: Mensajes) => ({
  type: SET_UPDATE_LAST_MESSAGE,
  payload: mensaje
});

export const setNuevaConversacionAction = (conversation: any) => ({
  type: SET_NUEVA_CONVERSACION,
  payload: conversation
});

export const updateMensajeConversacionAction = (message: any) => ({
  type: UPDATE_MENSAJE_CONVERSACION,
  payload: message
});

export const fetchChatConversaciones = (
  page: number = 1,
  limit: number = 20,
  search: string =''
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(fetchChatConversacionesRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      let endpoint = `conversaciones/users?page=${page}&limit=${limit}`;
      endpoint += `&txtSearch=${encodeURIComponent(search)}`;

      const response = await fetchWithIP(endpoint, { method: 'GET' });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener las conversaciones');
      }

      dispatch(fetchChatConversacionesSuccess(data.data, data.meta));
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al obtener las conversaciones';
      dispatch(fetchChatConversacionesFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const fetchMensajesConversaciones = (
  idConversation: number,
  skip: number = 0,
  limit: number = 30,
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(fetchMensajesConversacionRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      let endpoint = `conversaciones/mensajes/${idConversation}?skip=${skip}&limit=${limit}`;

      const response = await fetchWithIP(endpoint, { method: 'GET' });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener los mensajes');
      }

      dispatch(fetchMensajesConversacionSuccess(data.data, data.meta));
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al obtener los mensajes';
      dispatch(fetchMensajesConversacionFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};